module.exports = __webpack_public_path__ + "media/src/images/landing/clock-14761008d45f144b3b366a14fd924bef.svg";